// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};
  
  InstantSearchResultItemCollection.prototype.compileTemplate = function(){
    if (!this.isShow) {
			return '';
		}
		this.searchTerm = Utils.stripHtml(Globals.currentTerm);
		var searchLink = Utils.reBuildUrlBaseOnLocale('/collections/' + this.data.handle);
    if(boostPFSAppConfig.general.current_locale !=='en') {
      searchLink = searchLink.slice(3, searchLink.length)
    }
    
		var highlightedSuggestionResult = this._highlightSuggestionResult(this.data.title, this.searchTerm);
		return this.getTemplate()
			.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
			.replace(/{{escapedDataTitle}}/g, Utils.stripHtml(this.data.title))
			.replace(/{{escapedDataId}}/g, Utils.stripHtml(this.data.id))
			.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
			.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
			.replace(/{{searchLink}}/g, searchLink)
			.replace(/{{highlightedSuggestionResult}}/g, highlightedSuggestionResult);
	}

	
  
})();